module.exports = __webpack_public_path__ + "static/apprentice_wizard-3a482f402d81579e887c051ff7194fd6.jpeg";